// #endregion Interfaces

// #region Operations

/**
 * Calculate the left-hand offset for the playhead as a percentage.
 *
 * @param currentTime The current time on the timeline.
 * @param offset The left-hand offset of the timeline.
 * @param duration The total duration of the timeline.
 * @param zoom The zoom level applied to the timeline.
 */
export function calculatePlayheadOffset(currentTime, offset, duration, zoom) {
  const visibleDuration = duration * zoom;
  const offsetCurrentTime = currentTime - offset;

  return (offsetCurrentTime / visibleDuration) * 100;
}

/**
 * Calculate the left-hand offset of the timeline as a percentage.
 *
 * @param currentTime The current time on the timeline.
 * @param duration The total duration of the timeline.
 * @param zoom The zoom level applied to the timeline.
 */
export function calculateTimelineOffset(currentTime, duration, zoom) {
  const visibleDuration = duration * zoom;
  let offset = currentTime - visibleDuration / 2;
  if (offset < 0) {
    offset = 0;
  }

  if (currentTime > duration - visibleDuration / 2) {
    offset = duration - visibleDuration;
  }

  return offset;
}

/**
 * Generate the list of ticks to be displayed over the tracks.
 *
 * @param offset Where to start the list.
 * @param duration The total duration.
 * @param zoom The current zoom level.
 */
export function generateTicks(offset, duration, zoom, stepSize = 1) {
  const visibleDuration = duration * zoom;
  const tickCount = Math.floor(visibleDuration) + 1;
  const leftOffset = ((Math.ceil(offset) - offset) / visibleDuration) * 100;

  /*
   * The left-most index is the offset from where we start rendering ticks. An extra
   * step is subtracted from the start to make sure ticks don't disappear when they
   * are close to the start.
   */
  const leftMostIndex = stepSize - (Math.ceil(offset) % stepSize) - stepSize * 2;

  const ticks = [];
  for (let index = leftMostIndex; index < tickCount; index += stepSize) {
    ticks.push({
      time: Math.ceil(offset) + index,
      left: (index / visibleDuration) * 100 + leftOffset,
    });
  }

  return ticks;
}

export function SecondsToShortTime(timeInSeconds) {
  const hours = Math.floor(timeInSeconds / (60 * 60));
  const minutes = Math.floor((timeInSeconds % (60 * 60)) / 60);
  const seconds = timeInSeconds % 60;

  return `${pad(hours, 2)}:${pad(minutes, 2)}:${pad(seconds.toFixed(0), 2)}`;
}

export function SecondsToLongTime(timeInSeconds) {
  const hours = Math.floor(timeInSeconds / (60 * 60));
  const minutes = Math.floor((timeInSeconds % (60 * 60)) / 60);
  const seconds = timeInSeconds % 60;
  const milliseconds = timeInSeconds % 1;


  return `${pad(hours, 2)}:${pad(minutes, 2)}:${pad(seconds.toFixed(0), 2)}.${pad(milliseconds, 3)}`;
}

const pad = (num, size) => ('000000000' + num).substr(-size);

// #endregion Operations
